import { getClientCountry, getClientCurrency, getClientInterface, getClientLanguage } from './utils'

const trackers = {
  // Google Tag Manager
  gtm: {
    script: config =>
      `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.id}');`,
    noscript: config =>
      `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${config.id}" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
    track: (_config, payload) => {
      if (!window.dataLayer) return

      window.dataLayer.push(payload)
    },
  },
  // Facebook Pixel
  fbPixel: {
    script: config => `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${config.id}');
    // fbq('track', 'PageView');`,
    noscript: config => `<noscript><img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${config.id}&ev=PageView&noscript=1"
      /></noscript>`,
    track: (_config, payload) => {
      if (!window.fbq) return

      const event = payload.event
      delete payload.event

      const defaultPayload = {
        country: getClientCountry(),
        interface: getClientInterface(),
        language: getClientLanguage(),
      }

      const newPayload = { ...defaultPayload, ...payload }

      window.fbq('track', event, newPayload)
    },
  },
  // Google Conversion Tracking
  googleConversion: {
    scriptSrc: config =>
      `https://www.googletagmanager.com/gtag/js?id=${config.id}&l=dataLayerForConversion`,
    script: config => `window.dataLayerForConversion = window.dataLayerForConversion || [];
      function gtag(){dataLayerForConversion.push(arguments);}
      gtag('js', new Date());

      gtag('config', '${config.id}', {'send_page_view': false});`,
    track: (config, payload) => {
      if (!window.gtag) return

      const event = payload.event || 'conversion'
      if (payload.event) delete payload.event

      const defaultPayload = {
        value: 0.0,
        currency: getClientCurrency(),
      }

      if (payload.conversion_label) {
        defaultPayload.send_to = `${config.id}/${payload.conversion_label}`
        delete payload.conversion_label
      }

      const newPayload = { ...defaultPayload, ...payload }

      window.gtag('event', event, newPayload)
    },
  },
  // LinkedIn Insight Tag
  linkedinInsight: {
    script: config => `_linkedin_partner_id = "${config.id}";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);`,
    noscript: config =>
      `<noscript><img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=${config.id}&fmt=gif" /></noscript>`,
    track: (_config, payload) => {
      if (!window.lintrk) return

      window.lintrk('track', payload)
    },
  },
  // TikTok Pixel
  tiktokPixel: {
    script: config => `!function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};

        ttq.load('${config.id}');
        // ttq.page();
      }(window, document, 'ttq');`,
    track: (_config, payload) => {
      if (!window.ttq) return

      const event = payload.event
      delete payload.event

      window.ttq.track(event, payload)
    },
  },
}

export default trackers
